import { CalculatorOutlined } from "@ant-design/icons";
import { configurationAuthScope, CrudOp } from "@org-avp/avp-avengers-ui-shared-auth";
import { Translations, ViewIsAuthorized, ViewModule } from "@org-avp/avp-avengers-ui-shared-utils";
import de from "../../public/locales/de.json";
import en from "../../public/locales/en.json";
import { PrFamilyInfoView } from "./lazy-view";

const translations: Translations = { de, en };
const isAuthorized: ViewIsAuthorized = (authHelperCreator, { brand }) => {
  const authHelper = authHelperCreator(configurationAuthScope);
  return brand != null && authHelper.evaluate(CrudOp.READ, brand);
};

export const prFamilyInfoViewKey = "configuration_modular_prFamilyInfo/:projectId/:subprojectId/:brand/:modelYear/:mbvKeys";
export const prFamilyInfoViewModule: ViewModule = {
  viewKey: prFamilyInfoViewKey,
  viewEl: <PrFamilyInfoView/>,
  displayNameI18nKey: "configuration:prFamilyInfo.viewName",
  menuIconEl: <CalculatorOutlined/>,
  isAuthorized,
  translations,
};
